module.exports = __webpack_public_path__ + "img/drag.66e2a300.svg";